export const Panels = {
    GATE: "gate",
    CLIMATE: "climate",
    STEPPER: "stepper",
    LINKS: "links",
    ICONS: "icons"
} as const;

export type PanelValue = (typeof Panels)[keyof typeof Panels];